import { normalizeTopSellingEventsCategories } from '@utils/storeDataNormalization';
import topSellingEventsModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';

const STORE_NAME = 'categories';

const store = topSellingEventsModuleFactory.createModuleView(STORE_NAME, apiService, {
    customListFormatter: normalizeTopSellingEventsCategories,
    customListFetchFn: apiService.topSellingEvents.categories.get,
});

export default store;
